module.exports = __webpack_public_path__ + "static/PC-41ae5a3e8f72e14dc8efb4384923a449.png";